import React, { useState } from 'react'

import Container from 'components/atoms/Container'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Markdown from 'components/atoms/MarkdownContent'

import { string, arrayOf, object } from 'prop-types'

import config from 'config'

const { assets_url: assetsUrl } = config

const MajorProspect = ({ title, detail, list }) => {
  const [showAllJobs, setShowAllJobs] = useState(false)

  const toggleShowAll = () => setShowAllJobs(!showAllJobs)

  const jobs = !showAllJobs ?
    list.map((job, index) => ({ ...job, hideOnDesktop: index > 5 })) :
    list

  return (
    <div id="careers" className="major-prospect">
      <SectionContainer marginTop={120} className="major-prospect--fancy-bg">
        <Container>
          <div className="major-prospect__flex">
            <SectionTitle title={title} align="left" />

            <div className="major-prospect__content">
              <Markdown className="major-prospect__detail" content={detail} />
              <div className="major-prospect__list">
                {
                  jobs.map((job, idx) => (
                    <a
                      href={job.path}
                      className={`major-prospect__list-item ${job.hideOnDesktop ? 'major-prospect__list-item--desktop-hide' : 'swing-in-top-fwd'}`}
                      key={`job-prospect-${idx}`}
                    >
                      { job.name }
                    </a>
                  ))
                }
              </div>
              {
                  list.length > 6 &&
                  <a
                    href="#"
                    className="major-prospect__show-more"
                    onClick={(e) => {
                      e.preventDefault()
                      toggleShowAll()
                    }}
                  >
                    {showAllJobs ? 'Sembunyikan' : 'Lihat Selengkapnya'}
                  </a>
                }
            </div>

          </div>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .major-prospect {
            :global(&--fancy-bg) {
              @media screen and (min-width: 768px) {
                background-color: #fff;
                background-image: url(${assetsUrl}/assets/img/major_detail/rectangle-element.svg);
                background-position: left;
                background-position-y: 240px;
                background-repeat: no-repeat;
              }
            }
            :global(&__detail) {
              font-size: 16px;
              line-height: 1.5;
              :global(p) {
                margin-bottom: 8px;
              }
              @media screen and (min-width: 768px) {
                background-color: #fff;
                :global(p) {
                  margin-bottom: 16px;
                }
              }
            }
            &__list {
              display: flex;
              justify-content: flex-start;
              flex-wrap: nowrap;
              overflow: scroll;
              margin-left: -8px;
              margin-right: -8px;
              scroll-snap-type: x mandatory;
              @media screen and (min-width: 768px) {
                flex-wrap: wrap;
                overflow: unset;
              }
            }
            &__list-item {
              font-weight: bold;
              font-size: 16px;
              padding: 16px;
              background-image: linear-gradient(112deg, #00beff, #0fc3c4);
              color: #fff;
              border-radius: 8px;
              margin: 8px;
              height: 72px;
              display: flex;
              align-items: center;
              width: calc(calc(100%/2) - 16px);
              min-width: 248px;
              scroll-snap-align: start;
              cursor: pointer;
              &:focus, &:hover {
                text-decoration: none;
              }
              @media screen and (min-width: 768px) {
                &--desktop-hide {
                  display: none;
                }
                min-width: unset;
                width: calc(calc(100%/3) - 16px);
              }
            }
            &__show-more {
              display: none;
              font-size: 16px;
              font-weight: 700;
              color: #0fc3c4;
              margin-top: 1rem;
              margin-bottom: 1rem;
              &:focus, &:hover {
                text-decoration: none;
                outline: none;
              }
              @media screen and (min-width: 768px) {
                display: block;
              }
            }
            @media screen and (min-width: 768px) {
              &__flex {
                display: flex;
              }
              &__content {
                flex: 1;
                margin-left: 64px;
              }
            }
          }
          .swing-in-top-fwd {
            animation: swing-in-top-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
          }
          /* ----------------------------------------------
          * Generated by Animista on 2019-5-14 11:42:50
          * w: http://animista.net, t: @cssanimista
          * ---------------------------------------------- */

          /**
          * ----------------------------------------
          * animation swing-in-top-fwd
          * ----------------------------------------
          */
          @-webkit-keyframes swing-in-top-fwd {
            0% {  
              transform: rotateX(-100deg);
              transform-origin: top;
              opacity: 0;
            }
            100% {
              transform: rotateX(0deg);
              transform-origin: top;
              opacity: 1;
            }
          }
          @keyframes swing-in-top-fwd {
            0% {
              transform: rotateX(-100deg);
              transform-origin: top;
              opacity: 0;
            }
            100% {
              transform: rotateX(0deg);
              transform-origin: top;
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  )
}

MajorProspect.propTypes = {
  title: string,
  detail: string,
  list: arrayOf(object),
}

export default MajorProspect
